import { BaseResponse } from "../../../base/response/BaseResponse";
import { MapGroup } from "../../base/map/BaseMapRender";
import { ConteoAnimalControl } from "./ConteoAnimalControl";
import { OrtomosaicoControl } from "./OrtomosaicoControl";
import { Tooltip, TooltipRender } from "./TooltipRender";

export type ConfigTopActions<TResponse extends BaseResponse> = {
  toolTipItems: Tooltip<TResponse>[];
  withOrtomosaico: boolean;
  withConteo: boolean;
  onMountEnd?(
    element: HTMLElement,
    map: L.Map,
    mapItems: MapGroup<TResponse>[],
  ): void;
};

export class TopActions<TResponse extends BaseResponse> {
  private _toolTipRender = new TooltipRender<TResponse>();
  private _ortomosaicoControl: OrtomosaicoControl | null = null;
  private _conteoAnimalControl: ConteoAnimalControl | null = null;

  mount(
    element: HTMLElement,
    map: L.Map,
    mapItems: MapGroup<TResponse>[],
    config: ConfigTopActions<TResponse>,
  ) {
    if (config.toolTipItems.length > 0) {
      this._toolTipRender.init(element, config.toolTipItems, mapItems);
      this._toolTipRender.triggerTooltipFieldDef();
    }

    if (config.withOrtomosaico) {
      this._ortomosaicoControl = new OrtomosaicoControl();
      this._ortomosaicoControl.init(element, map);
    }

    if (config.withConteo) {
      this._conteoAnimalControl = new ConteoAnimalControl();
      this._conteoAnimalControl.init(element, map);
    }

    if (config.onMountEnd) {
      config.onMountEnd(element, map, mapItems);
    }
  }

  dispose() {
    this._toolTipRender.dispose();
    this._ortomosaicoControl?.dispose();
    this._conteoAnimalControl?.dispose();
  }
}
